export default "__VITE_ASSET__DWimogs6__"